import { MSG } from '../consts/Messages';

export const isEmpty = (value) => {
    return value === undefined || value === null || value === '';
  }


/**
 * Site bildirimleri (toast): sağ üstte (telefonda üstte tam genişlik), kendiliğinden kaybolan küçük kartlar. Eskiden
 * SweetAlert ekran ortasında "Tamam"lı pencere açıyordu; her "Çıkış işlemi başarılı" sayfayı kesiyordu (2026-11-02).
 * Kütüphanesiz düz DOM; imza aynı: showAlert(mesaj, tür, başlık). Hata ve uyarılar daha uzun kalır, tıklayınca kapanır.
 */
const TOAST_SIMGE = { success: "✓", error: "!", warning: "!", info: "i", question: "?", default: "i" };
const TOAST_BASLIK = { success: "Tamam", error: "Bir sorun oluştu", warning: "Dikkat", info: "Bilgi", question: "Bilgi", default: "Bilgi" };

const mesajMetni = (m) => {
  let t = m == null ? "" : typeof m === "string" ? m : (m.message || String(m));
  t = t.trim();
  if (/Network Error/i.test(t)) return "Sunucuya ulaşılamadı, internet bağlantını kontrol edip tekrar dene.";
  if (/^AxiosError/i.test(t) || /status code 5\d\d/i.test(t)) return "Sunucu şu an cevap vermiyor, birazdan tekrar dene.";
  return t;
};

export const showAlert = (message, type, title) => {
  if (typeof document === "undefined") return;
  const tur = TOAST_SIMGE[type] ? type : "info";
  let kutu = document.getElementById("iu-toastlar");
  if (!kutu) {
    kutu = document.createElement("div");
    kutu.id = "iu-toastlar";
    kutu.setAttribute("aria-live", "polite");
    document.body.appendChild(kutu);
  }
  while (kutu.children.length >= 3) kutu.firstChild.remove();
  const metin = mesajMetni(message);
  const baslik = (title || "").replace(/!\s*$/, "").trim() || (metin ? TOAST_BASLIK[tur] : "");
  const t = document.createElement("div");
  t.className = "iu-toast iu-toast-" + tur;
  t.setAttribute("role", tur === "error" ? "alert" : "status");
  const sure = tur === "error" || tur === "warning" ? 6000 : 3500;
  t.innerHTML = '<span class="iu-toast-simge" aria-hidden="true"></span><div class="iu-toast-metin"><b></b><span></span></div>'
    + '<button type="button" class="iu-toast-kapat" aria-label="Kapat">×</button><i class="iu-toast-sure" aria-hidden="true"></i>';
  t.querySelector(".iu-toast-simge").textContent = TOAST_SIMGE[tur];
  t.querySelector("b").textContent = baslik || metin;
  t.querySelector(".iu-toast-metin span").textContent = baslik ? metin : "";
  t.querySelector(".iu-toast-sure").style.animationDuration = sure + "ms";
  let zamanlayici;
  const kapat = () => {
    clearTimeout(zamanlayici);
    t.classList.add("iu-toast-cikis");
    setTimeout(() => t.remove(), 220);
  };
  t.addEventListener("click", kapat);
  t.addEventListener("mouseenter", () => { clearTimeout(zamanlayici); t.classList.add("iu-toast-dur"); });
  t.addEventListener("mouseleave", () => { t.classList.remove("iu-toast-dur"); zamanlayici = setTimeout(kapat, 1500); });
  kutu.appendChild(t);
  zamanlayici = setTimeout(kapat, sure);
}